import { Box, Typography, Button, Link } from '@mui/material';

export default function DriversStep({ onRetry, onCancel }) {
  return (
    <Box sx={{ textAlign: 'center', maxWidth: 420, mx: 'auto', py: 4 }}>
      <Typography variant="h6" gutterBottom>We couldn&apos;t find your sensor</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Make sure the USB cable is plugged in firmly. On Windows you may need a small one-time driver:{' '}
        <Link href="https://learn.sparkfun.com/tutorials/how-to-install-ch340-drivers#drivers-if-you-need-them" target="_blank" rel="noopener noreferrer">install the USB driver</Link>, then plug the sensor back in.
      </Typography>
      <Button variant="contained" onClick={onRetry}>Try again</Button>
      {onCancel && <Button sx={{ ml: 1 }} onClick={onCancel}>Cancel</Button>}
    </Box>
  );
}
